import { CssColorScheme } from '../utils/iframe';

export const lasPostMessageTypes = {
  COMPLETE: 'COMPLETE',
  USER_CANCELLED: 'USER_CANCELLED',
  ASK_APP_ORIGIN: 'ASK_APP_ORIGIN',
  GIVE_APP_ORIGIN: 'GIVE_APP_ORIGIN',
} as const;

export type LasPostMessageType =
  typeof lasPostMessageTypes[keyof typeof lasPostMessageTypes];

export const interactionIntents = {
  LOAN_APPLICATION: 'loanApplication',
  PAYMENT: 'PAYMENT',
} as const;

export type InteractionIntent =
  typeof interactionIntents[keyof typeof interactionIntents];

/**
 * Color scheme forwarded verbatim to the LAS web app as the `theme` query
 * param on the launch URL. The integrator (partner app) is the source of truth
 * and supplies the value; the SDK does not detect or resolve the scheme itself.
 * When omitted, the `theme` param is left off and the web app applies its
 * default (light for gateway sessions).
 */
export const colorSchemes = {
  DARK: 'dark',
  LIGHT: 'light',
  SYSTEM: 'system',
} as const;

export type ColorScheme = typeof colorSchemes[keyof typeof colorSchemes];

/**
 * Maps a ColorScheme to a valid CSS `color-scheme` value. The CSS property
 * has no `system` keyword — `light dark` is its equivalent, letting the
 * browser pick based on the OS/user preference.
 */
export const toCssColorScheme = (colorScheme?: ColorScheme): CssColorScheme => {
  if (colorScheme === colorSchemes.SYSTEM) return 'light dark';
  return colorScheme ?? '';
};
